export default {
    oauth: {
        url: 'https://oauth-abe.dev.pixellot.tv',
        clientId: 'cms-internal',
        redirectUrl: 'https://vpum-dev.pixellot.tv',
    },
};
